// Export utility: converts data arrays to styled Excel files and triggers browser download
import { saveStyledXlsx } from './excelStyle';

export function downloadCSV(data, filename) {
  if (!data || data.length === 0) { alert('No data to export'); return; }
  const headers = Object.keys(data[0]);
  const rows = [headers, ...data.map(row => headers.map(h => row[h] ?? ''))];
  const csv = rows.map(r => r.map(v => `"${String(v).replace(/"/g, '""')}"`).join(',')).join('\n');
  const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}

export function downloadExcel(sheets, filename) {
  // sheets = [{ name: 'Sheet1', data: [...] }, ...]
  // Writes a styled workbook (coloured header, wrapped text, borders, widths) via ./excelStyle
  try {
    const list = (sheets || []).filter(sh => sh && sh.data && sh.data.length);
    if (!list.length) { alert('No data to export'); return; }
    saveStyledXlsx(filename, list.map(sh => ({ name: sh.name, title: sh.title || sh.name, rows: sh.data })));
  } catch (e) {
    // Fallback to CSV if the styled export fails
    if (sheets && sheets[0]) downloadCSV(sheets[0].data, String(filename).replace('.xlsx', '.csv'));
  }
}

// Format helpers
export function fmtDate(d) { return d ? new Date(d).toLocaleDateString('en-IN') : ''; }
export function fmtCurrency(n) { return n != null ? Number(n).toLocaleString('en-IN') : '0'; }
